import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

(function() {
	window.dataLayer = window.dataLayer || [];
	window.gtag = function(){ window.dataLayer.push(arguments); }

	var gtag_ua = process.env.REACT_APP_GTAG_UA;
	var gtag_ua2 = process.env.REACT_APP_GTAG_UA2;

	if (!gtag_ua && !gtag_ua2) {
		return;
	}

	window.gtag('js', new Date());

	window.gtag('config', gtag_ua || gtag_ua2);
	window.onhashchange = function() {
		var change = {
			page_title: window.location.hash.substr(1),
			page_location: window.location.href,
			page_path: window.location.pathname + window.location.hash,
		};
		if (gtag_ua) {
			change.send_to = gtag_ua;
			window.gtag('event', 'page_view', change);
		}
		if (gtag_ua2) {
			change.send_to = gtag_ua2;
			window.gtag('event', 'page_view', change);
		}
	};

	var s = document.createElement("script");
	s.src = "https://www.googletagmanager.com/gtag/js?id=" + (gtag_ua || gtag_ua2);
	s.setAttribute("async", "");
	document.head.appendChild(s);
})();

ReactDOM.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
	document.getElementById('root')
);
